import { Pipe, PipeTransform } from '@angular/core';
import { ConsentPeriod, CONSENT_PERIOD_OPTIONS } from '../models/consent.model';

@Pipe({
  name: 'consentPeriod'
})
export class ConsentPeriodPipe implements PipeTransform {
  transform(value: ConsentPeriod | null | undefined): string {
    if (value === null || value === undefined) {
      return '';
    }
    
    const option = CONSENT_PERIOD_OPTIONS.find(opt => opt.value === value);
    return option ? option.label : '';
  }
}
